export default __webpack_public_path__ + "static/media/htmlBW.bac89765.webp";